import { DAY_BOUNDARY_TIME_ZONE } from '@kiao-voice/core'

/** Campaign copy is always dated in Taipei time — the campaign's own timezone. */
const CAMPAIGN_TIME_ZONE = DAY_BOUNDARY_TIME_ZONE

/** `2026/09/30` — the date form used throughout the campaign design. */
export function formatCampaignDate(iso: string | null | undefined): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat('zh-TW', {
    timeZone: CAMPAIGN_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
    .format(date)
    .replaceAll('-', '/')
}

/**
 * Share of the quota already claimed, 0–100. Uncapped campaigns have no bar,
 * which is why this returns null rather than 0 for them.
 */
export function claimedPercent(remaining: number | null, maxClaims: number | null): number | null {
  if (remaining === null || maxClaims === null || maxClaims <= 0) return null
  const claimed = Math.min(Math.max(maxClaims - remaining, 0), maxClaims)
  return Math.round((claimed / maxClaims) * 100)
}

/** Whole days until `iso`, floored at 0. Used by the next-wave countdown. */
export function daysUntil(iso: string | null | undefined, now: Date = new Date()): number | null {
  if (!iso) return null
  const target = new Date(iso)
  if (Number.isNaN(target.getTime())) return null
  const diffMs = target.getTime() - now.getTime()
  if (diffMs <= 0) return 0
  return Math.ceil(diffMs / (24 * 60 * 60 * 1000))
}
